module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "学生课时",
      "width": "1100"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5303d6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/StudentClassHourModal.vue
// module id = 1965
// module chunks = 8